<template>
  <div>
    <el-dialog
      width="500px"
      title="状态更新"
      :visible.sync="pwdVisible"
      @close="closePwdDialog"
      class="upState"
    >
      <el-form
        ref="statusForm"
        :model="statusForm"
        :rules="rules"
        label-width="90px"
      >
        <el-form-item label="当前状态：">
          <el-select v-model.trim="currentState" @change="stateChange">
            <el-option
              :key="value.value"
              v-for="value in currentStateList"
              :disabled="value.disabled"
              :label="value.name"
              :value="value.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="由谁受理：" v-show="currentState == 1">
          <el-input v-model.trim="userName" disabled> </el-input>
        </el-form-item>
        <el-form-item
          label="问题类型："
          prop="problemTypes"
          v-show="currentState == 2"
        >
          <el-cascader
            v-model.trim="statusForm.problemTypes"
            :options="problemTypesList"
            collapse-tags
            :props="typeProps"
            @change="problemTypesChange"
          ></el-cascader>
        </el-form-item>
        <el-form-item
          label="问题概述："
          prop="issueAnOverview"
          v-show="currentState == 2"
        >
          <el-input
            placeholder="请输入，不超过200个字"
            autosize
            type="textarea"
            maxlength="200"
            v-model.trim="statusForm.issueAnOverview"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="处理结论："
          prop="resultHand"
          v-show="currentState == 2"
        >
          <el-input
            placeholder="请输入，不超过200个字"
            autosize
            type="textarea"
            maxlength="200"
            v-model.trim="statusForm.resultHand"
          ></el-input>
        </el-form-item>
      </el-form>
      <!-- <reset-status-form
        :data="pwdForm"
        @clickCancel="closePwdDialog"
        @clickConfirm="confirmPwdAction"
      ></reset-status-form> -->
      <span slot="footer" class="dialog-footer">
        <el-button
          type="info"
          size="small"
          style="border-radius: 2px"
          @click="closePwdDialog"
          >取消</el-button
        >
        <el-button
          type="primary"
          size="small"
          style="border-radius: 2px"
          @click="confirm"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { userListFeedbackTypes, updateFeedbackStatus } from "@/api/userApi";
export default {
  components: {},
  props: {
    pwdDialogVisible: Boolean,
    statusFormCurrentState: Number,
    UpdateStateData: Object,
  },

  data() {
    return {
      typeProps: {
        value: "Id",
        label: "Name",
        children: "children",
        expandTrigger: "hover",
        multiple: true,
      },
      rules: {
        problemTypes: [
          { required: true, message: "请选择问题类型", trigger: "change" },
        ],
      },
      userName: null,
      statusForm: {
        problemTypes: [],
      },
      currentStateList: [
        {
          key: 0,
          value: 0,
          name: "未处理",
          disabled: false,
        },
        {
          key: 1,
          value: 1,
          name: "进行中",
          disabled: false,
        },
        {
          key: 2,
          value: 2,
          name: "已完成",
          disabled: false,
        },
      ],
      problemTypesList: [],
    };
  },
  watch: {
    stateHandle: {
      handler(val) {
        this.currentStateList.forEach((item) => {
          if (item.value < val) {
            item.disabled = true;
          } else {
            item.disabled = false;
          }
        });
      },
      immediate: true,
    },
    //  currentState(val){
    //   this.currentState=val
    //   },
  },
  computed: {
    stateHandle() {
      return this.UpdateStateData.Status;
    },
    pwdVisible: {
      get() {
        this.initStatusForm();
        return this.pwdDialogVisible;
      },
      set(value) {
        this.$emit("update:pwdDialogVisible", value);
      },
    },
    currentState: {
      get() {
        return this.statusFormCurrentState;
      },
      set(value) {
        this.$emit("update:statusFormCurrentState", value);
      },
    },
  },

  //方法集合
  methods: {
    stateChange() {
      this.initStatusForm();
    },
    async updateFeedbackStatusFn() {
      let params = {
        status: this.currentState,
        id: this.UpdateStateData.id,
      };
      if (this.currentState === 0) {
        this.$message({
          type: "error",
          message: "不能将状态改为未处理！",
        });
        return;
      } else if (this.currentState === 1) {
        //暂时不需要传入受理人信息
      } else if (this.currentState === 2) {
        if (
          !this.statusForm.problemTypes ||
          this.statusForm.problemTypes.length == 0
        ) {
          this.$message({
            message: "问题类型不能为空",
            type: "error",
          });
          return;
        }

        params.typeId = this.statusForm.problemTypes
          .map((item) => item[item.length - 1])
          .join(",");
        params.overview = this.statusForm.issueAnOverview;
        params.conclusion = this.statusForm.resultHand;
      }
      let res = await updateFeedbackStatus(params);
      if (res.data.data.result) {
        this.$emit("changFeedback");
        this.$message({
          type: "success",
          message: "更新成功!",
        });
        this.pwdVisible = false;
      } else {
        this.$message({
          type: "error",
          message: "更新失败!",
        });
      }
    },
    async userListFeedbackTypesFn() {
      let problemTypesList = [];
      let pid = 99999;
      let res = await userListFeedbackTypes();
      res.data.data.result.map((item) => {
        if (item.Pid === 0) {
          problemTypesList.push({
            ...item,
            children: [],
          });
        }
        problemTypesList.forEach((ite) => {
          if (ite.Id === item.Pid) {
            ite.children.push(item);
          }
        });
      });

      this.problemTypesList = problemTypesList;
    },
    confirm() {
      this.$confirm("请确认状态更新无误", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.updateFeedbackStatusFn();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消更新",
          });
        });
    },
    problemTypesChange() {},

    initStatusForm() {
      if (
        this.UpdateStateData?.TypeIds?.length &&
        this.problemTypesList?.length
      ) {
        for (let i = 0; i < this.UpdateStateData.TypeIds.length; i++) {
          for (let k = 0; k < this.problemTypesList.length; k++) {
            if (this.problemTypesList[k].children) {
              for (
                let j = 0;
                j < this.problemTypesList[k].children.length;
                j++
              ) {
                if (
                  this.UpdateStateData.TypeIds[i] ===
                  this.problemTypesList[k].children[j].Id
                ) {
                  this.UpdateStateData.TypeIds[i] = [
                    this.problemTypesList[k].Id,
                    this.problemTypesList[k].children[j].Id,
                  ];
                }
              }
            }
          }
        }
      }
      this.$set(this.statusForm, "problemTypes", this.UpdateStateData.TypeIds);
      this.$set(
        this.statusForm,
        "issueAnOverview",
        this.UpdateStateData.Overview
      );
      this.$set(this.statusForm, "resultHand", this.UpdateStateData.Conclusion);
    },
    closePwdDialog() {
      this.initStatusForm();
      this.pwdVisible = false;
    },
  },
  created() {
    this.userName = localStorage.getItem("userName");
    this.currentState = this.statusFormCurrentState;
    this.userListFeedbackTypesFn();
  },
  mounted() {},
  beforeCreate() {},
  beforeMount() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  activated() {},
};
</script>
<style lang="less" scoped>
.upState {
  /deep/ .el-dialog__body {
    border: 1px solid #e5e6eb;
    border-left: 0;
    border-right: 0;
  }
  /deep/ .el-dialog__header {
    text-align: center;
    span {
      font-weight: 500;
      font-size: 16px;
      color: #1d2129;
      line-height: 24px;
      font-style: normal;
    }
  }
}
</style>
